import { render, staticRenderFns } from "./PriceInputWrapper.vue?vue&type=template&id=599fa092&"
import script from "./PriceInputWrapper.vue?vue&type=script&lang=js&"
export * from "./PriceInputWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports